//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'app',
  data () {
    return {
      haveTabber: false, // 是否有底部导航
      closeMenu: true
    }
  },
  watch: {
    $route (to) {
      this.closeMenu = true
      const pathArr = ['/home', /*'/classify',*/ /*'/usercenter',*/ '/login', '/register', '/receive']
      console.log("进入页面索引"+pathArr.indexOf(to.path))
      if (pathArr.indexOf(to.path) !== -1) {
        this.haveTabber = true
      } else {
        this.haveTabber = false
      }
    }
  },
  methods: {
    // 移动悬浮菜单
    menuMove (e) {
      if (e.touches[0].clientX > 40 && e.touches[0].clientX < window.innerWidth - 5) {
        e.target.style.right = window.innerWidth - e.touches[0].clientX + 'px'
      }
      if (e.touches[0].clientY > 0 && e.touches[0].clientY < window.innerHeight - 40) {
        e.target.style.top = e.touches[0].clientY + 'px'
      }

      if ((window.innerWidth - e.touches[0].clientX <= 10)&&(e.touches[0].clientY <= 10))
      {
          let vconDom = document.getElementById('__vconsole').style.display = "block";;
          //console.log(vconDom)
          //this.toggleClass(vconDom,'show')
      }
      e.preventDefault()
    },
    hasClass(obj, cls) {
      return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
    },
    addClass(obj, cls) {
      if (!this.hasClass(obj, cls)) obj.className += " " + cls;
    },
    toggleClass(obj,cls){
      if(this.hasClass(obj,cls)){
        //this.removeClass(obj, cls);
      }else{
        this.addClass(obj, cls);
      }
    },
    removeClass(obj, cls) {
      if (this.hasClass(obj, cls)) {
        var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        obj.className = obj.className.replace(reg, ' ');
      }
    },

  }
}



// WEBPACK FOOTER //
// ./src/App.vue